import { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form@latest';

import { CAGE_NUMBER, REPEATING } from '../Recaging.utils';
import type { ProposedCage } from '../Recaging.utils';

/**
 * Form data interface for recaging
 */
interface RecagingFormData {
  per_cage: number;
  sequencePrefix: string;
  sequenceStarting: string;
}

/**
 * Custom hook for recaging form management
 */
export const useRecagingForm = () => {
  const [idGenerationMethod, setIdGenerationMethod] = useState(REPEATING);
  const [cageNamingMethod, setCageNamingMethod] = useState(CAGE_NUMBER);
  const [deleteCages, setDeleteCages] = useState(false);
  const [existingGroupCageNames, setExistingGroupCageNames] = useState(false);
  const [tags, setTags] = useState<string[]>([]);
  const [proposedCages, setProposedCages] = useState<ProposedCage[]>([]);

  const formMethods = useForm<RecagingFormData>({
    defaultValues: {
      per_cage: 5,
      sequencePrefix: '',
      sequenceStarting: '',
    },
  });

  const handleTagChange = useCallback((newTags: string[]) => {
    setTags(newTags);
  }, []);

  return {
    // Form methods
    formMethods,

    // Form state
    idGenerationMethod,
    setIdGenerationMethod,
    cageNamingMethod,
    setCageNamingMethod,
    deleteCages,
    setDeleteCages,
    existingGroupCageNames,
    setExistingGroupCageNames,
    tags,
    setTags,
    proposedCages,
    setProposedCages,
    handleTagChange,
  };
};
